import { z } from 'zod';
import { pathSchema, traitKeySchema } from './content-id.js';
/**
 * Условие применения эффекта (rules-engine.md, раздел 4).
 *
 * Условие бывает простым и составным. Составное — плоский список
 * простых, объединённых «И» (D22): все должны выполниться. «ИЛИ»
 * и вложенность запрещены — «ИЛИ» раскладывается на два эффекта,
 * а вложенность делает условие нечитаемым в редакторе предметов.
 */
/** Литерал сравнения: значения из контекста — строки, числа и флаги. */
export const conditionLiteralSchema = z.union([z.string(), z.number(), z.boolean()]);
const comparisonSchema = z.strictObject({
    path: pathSchema,
    op: z.enum(['eq', 'neq']),
    value: conditionLiteralSchema.nullable(),
});
const orderingSchema = z.strictObject({
    path: pathSchema,
    op: z.enum(['gte', 'lte']),
    // Порядок определён только на числах: сравнивать строки «больше»
    // и «меньше» — способ получить неожиданный порядок по алфавиту.
    value: z.number(),
});
const membershipSchema = z.strictObject({
    path: pathSchema,
    op: z.literal('in'),
    // Для `in` значение — список. Пустой список допустим и означает
    // «никогда»: это данные, а не ошибка формы.
    value: z.array(conditionLiteralSchema),
});
/**
 * Условие на признак (D21.3): «есть в наборе» и «нет в наборе».
 * Работает в обе стороны — иначе нельзя описать ни «пока не связан»,
 * ни «только без доспеха».
 */
const traitSchema = z.strictObject({
    path: pathSchema,
    op: z.enum(['has', 'has_not']),
    value: traitKeySchema,
});
/** Простое условие: одно сравнение по одному пути. */
export const simpleConditionSchema = z.union([
    comparisonSchema,
    orderingSchema,
    membershipSchema,
    traitSchema,
]);
/**
 * Составное условие: «И» плоским списком (D22). Один элемент в списке
 * бессмыслен — это простое условие, записанное сложнее, поэтому
 * минимум два.
 */
export const allConditionSchema = z.strictObject({
    all: z.array(simpleConditionSchema).min(2),
});
export const conditionSchema = z.union([simpleConditionSchema, allConditionSchema]);
//# sourceMappingURL=condition.js.map